// 医学会
const scholarTextArr = [
  { text: '注册用户：中华医学会杂志用户系统中处于激活状态的用户。' },
  { text: '发文作者：本次推送论文的所有署名作者（带邮箱的）。' },
  { text: '引证关系作者：本次推送论文引证的期刊的作者。' },
  { text: '引用关系作者：本次推送论文引用的期刊的作者。' },
  { text: '期刊会员：订阅期刊年卡的用户。' },
  { text: '订购用户：通过期刊官网完成期刊的订阅购买操作的用户。' },
  {
    text:
      'Emali Alert 订阅用户：未注册为平台用户，但通过Emali Alert直接订阅服务的用户。'
    // hides: [1]
  },
  { text: '白名单：是指通过白名单导入的学者，为集群/编辑部指定推送的学者。' },
  {
    text:
      '编委：中华医学会旗下期刊现任编委，通常包括主编、副主编、执行编委、普通编委、青年编委等。'
  },
  { text: '审稿人：全平台参与中华医学会旗下期刊审稿工作的独立专家。' },
  { text: '投稿人：全平台向中华医学会旗下期刊投稿的独立作者。' }
]

// 工信
const productTextArr = [
  { text: '发文作者：本次推送论文的所有署名作者（带邮箱的）。' },
  {
    text: '发文作者的共同作者：和本次推送论文的作者一起发表过其他论文的作者。'
  },
  {
    text:
      '发文作者的同机构学者：本次推送论文发文作者所在机构（精确到二级机构）的全部学者。'
  },
  {
    text:
      '引用期刊作者：（引用刊，指本刊论文引用文献的发表刊物）本次推送论文引用的期刊的作者。'
  },
  { text: '引用论文作者：本次推送论文引用的论文的作者。' },
  { text: '引用论文（二次）作者：本次推送论文二次引用的论文的作者。' },
  { text: '共引作者：共同引用了本次推送论文的作者。' },
  {
    text:
      '引证期刊作者：（引证刊，指本刊论文被引用文献的发表刊物）本次推送论文被引用期刊的作者。'
  },
  { text: '引证论文作者：本次推送论文被引用论文的作者。' },
  { text: '引证论文（二次）作者：本刊/本期论文被二次引用的论文的作者。' },
  { text: '本刊机构学者：近五年在本刊发文的作者所在机构的学者。' },
  { text: '引用机构学者： 引用刊作者的同机构学者。' },
  { text: '引证机构学者： 引证刊作者的同机构学者。' },
  {
    text:
      '白名单：是指由编辑部提供的名单，是编辑部指定推送的学者，一般包含编辑部各成员、审稿专家、积累的历史投稿作者等。'
  },
  { text: '编辑：本刊的全部编辑。' },
  { text: '编委：本刊的全部编委。' },
  {
    text:
      '关键词匹配：用本次推送论文的关键词去匹配库里包含该关键词的论文，然后选取这些论文的作者。'
  },
  {
    text:
      '共现词匹配：用本次推送论文的关键词去匹配库里包含该关键词的论文，出现2次以上的叫共现词，所以是选取有2个以上相同关键词的论文的作者。'
  },
  { text: '本领域期刊作者：同领域刊，指与本刊具有相同中信所分类的期刊。' },
  { text: '本领域机构学者：同领域机构，指同领域期刊中文献作者的机构。' },
  { text: '自定义期刊：自定义期刊的作者，可根据客户需求设置指定推送的期刊。' },
  { text: '自定义机构：自定义机构的学者，可根据客户需求设置指定推送的机构。' },
  {
    text: '本期导入学者：平台支持导入客户提供的学者或指定推送的学者（带邮箱）。'
  },
  {
    text:
      '自定义关键词：用自定义的关键词去匹配库里包含该关键词的论文，然后选取这些论文的作者，仅对本任务生效。'
  }
]

const scholarSources = (type, arr = []) => {
  return arr.filter((item) =>
    item.hides && item.hides.length ? !item.hides.includes(Number(type)) : true
  )
}

const tooltipMap = {
  集群: '本集群下所有子刊',
  本刊: '本任务论文的所有来源刊',
  本期: '本任务论文'
}
export { scholarSources, scholarTextArr, productTextArr, tooltipMap }
